import moment from 'moment';

export const dateDDMMYYYYtoISO = (value: any) => moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD');

export const dateDDMMMYYYYtoISO = (value: any) => moment(value, 'DD-MMM-YYYY').format('YYYY-MM-DD');

export const dateISOtoDDMMYYYY = (value: any) => moment(value).format('DD/MM/YYYY');

export const dateISOtoDDMMMYYYY = (value: any, format = 'YYYY-MM-DDTHH:mm:ssZ') =>
  moment(value, format).format('DD-MMM-YYYY').toUpperCase();

export const dateISOtoFullDateAndTime = (value: string): string => moment(value).format('YYYY-MMDD-HHmmss');

export const getDuration = (from: any, to: any, format = 'DD-MMM-YYYY') =>
  moment.duration(moment(from, format).diff(moment(to, format))).toISOString();

export const dateISOtoAge = (from: any, to: any) => moment(to || undefined).diff(moment(from), 'years');
